// extracted by mini-css-extract-plugin
export default {"status":"stlyes_status__+gc6E","new":"stlyes_new__oiYW+","error":"stlyes_error__g-1sB","succes":"stlyes_succes__AEFpD","default_good":"stlyes_default_good__KVDZm"};